var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInfoRed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E60046",
  d: "M9.598 6.493h-1.2V13.2h1.2zm0-2.293h-1.2v1.2h1.2zM0 0v17.997h17.997V0H.001Zm16.797 16.797H1.2V1.2h15.596v15.597Z"
})));
export default SvgInfoRed;